
// srcs/frontend/src/components/proposal/ProposalShell.tsx
import React from 'react';
import { Redirect, Route, Switch, useParams, useRouteMatch } from 'react-router-dom';
import { Box, LinearProgress, Alert } from '@mui/material';
import Sidebar from './Sidebar.tsx';
import { ProposalProvider, useProposal } from './state/ProposalContext.tsx';

import SeedsPage from './pages/SeedsPage.tsx';
import GapPage from './pages/GapPage.tsx';
import RoiPage from './pages/RoiPage.tsx';
import DraftPage from './pages/DraftPage.tsx';

type ParamsNew = {}; // /proposals/new/*
type ParamsDetail = { sessionId: string }; // /proposals/:sessionId/*

/** 内部レンダ：ロードやエラー状況に応じて右側を切替 */
function RightPane() {
  const { path } = useRouteMatch();
  const { loading, error } = useProposal();

  if (loading) {
    return <Box sx={{ p: 2 }}><LinearProgress /></Box>;
  }
  if (error) {
    return <Box sx={{ p: 2 }}><Alert severity="error">{error}</Alert></Box>;
  }

  return (
    <Switch>
      <Route exact path={`${path}`}>
        <Redirect to={`${path}/seeds`} />
      </Route>
      <Route path={`${path}/seeds`} component={SeedsPage} />
      <Route path={`${path}/gap`} component={GapPage} />
      <Route path={`${path}/roi`} component={RoiPage} />
      <Route path={`${path}/draft`} component={DraftPage} />
    </Switch>
  );
}

/** /proposals/new/* 用: 新規モード */
export function ProposalShellNew() {
  const { path } = useRouteMatch<ParamsNew>();
  return (
    <ProposalProvider mode="new">
      <Box sx={{ display: 'flex', height: 'calc(100vh - 32px)', p: 2, gap: 2 }}>
        <Sidebar />
        <Box sx={{ flex: 1, minWidth: 0, overflow: 'auto' }}>
          <RightPane />
        </Box>
      </Box>
    </ProposalProvider>
  );
}

/** /proposals/:sessionId/* 用: 詳細モード */
export function ProposalShellDetail() {
  const { sessionId } = useParams<ParamsDetail>();
  const { path } = useRouteMatch<ParamsDetail>();

  return (
    <ProposalProvider mode="detail" sessionIdFromRoute={sessionId}>
      <Box sx={{ display: 'flex', height: 'calc(100vh - 32px)', p: 2, gap: 2 }}>
        <Sidebar />
        <Box sx={{ flex: 1, minWidth: 0, overflow: 'auto' }}>
          <RightPane />
        </Box>
      </Box>
    </ProposalProvider>
  );
}
